module.exports = __webpack_public_path__ + "static/media/How you can create or generate new invoices stagewise.703dda22.png";